import { useEffect } from "react";
import { useTranslation } from "react-i18next";

// Applies dir + lang + font-family on <html> based on i18n language.
export default function LanguageProvider({ children }) {
  const { i18n } = useTranslation();

  useEffect(() => {
    const lang = i18n.language?.startsWith("ar") ? "ar" : "en";
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    if (lang === "ar") {
      document.body.classList.add("font-arabic");
    } else {
      document.body.classList.remove("font-arabic");
    }
  }, [i18n.language]);

  return children;
}
